import {
    BASEMENT_DEVELOPMENT_TYPES,
    BASEMENT_TYPES,
    ROOF_COVERING_TYPES,
    ROOF_DEVELOPMENT_TYPES,
    ROOF_SHAPES,
    WINDOW_TYPES,
} from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { optionValues } from './optionValues';
import type { StepProps } from './types';
import { FormCheckboxGroup, FormRadioGroup } from '../FormControls';

export const RoofBasementWindowsStep: React.FC<StepProps> = ({ disabled, realEstateIndex }) => {
    const { t } = useTranslation();
    const prefix = `immobilien.${realEstateIndex}.baubeschreibung.dachKellerFenster` as const;
    return (
        <div className="space-y-3">
            <FormRadioGroup
                name={`${prefix}.dachausbau`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.GROUPS.ROOF_DEVELOPMENT')}
                options={optionValues(
                    ROOF_DEVELOPMENT_TYPES,
                    t,
                    'REAL_ESTATE.BUILDING_DESCRIPTION.OPTIONS.ROOF_DEVELOPMENT',
                )}
                disabled={disabled}
            />
            <FormRadioGroup
                name={`${prefix}.dachform`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.GROUPS.ROOF_SHAPE')}
                options={optionValues(ROOF_SHAPES, t, 'REAL_ESTATE.BUILDING_DESCRIPTION.OPTIONS.ROOF_SHAPE')}
                disabled={disabled}
            />
            <FormRadioGroup
                name={`${prefix}.dacheindeckung`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.GROUPS.ROOF_COVERING')}
                options={optionValues(ROOF_COVERING_TYPES, t, 'REAL_ESTATE.BUILDING_DESCRIPTION.OPTIONS.ROOF_COVERING')}
                disabled={disabled}
            />
            <FormCheckboxGroup
                name={`${prefix}.fenster`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.GROUPS.WINDOWS')}
                options={optionValues(WINDOW_TYPES, t, 'REAL_ESTATE.BUILDING_DESCRIPTION.OPTIONS.WINDOWS')}
                disabled={disabled}
            />
            <FormRadioGroup
                name={`${prefix}.kellerart`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.GROUPS.BASEMENT_TYPE')}
                options={optionValues(BASEMENT_TYPES, t, 'REAL_ESTATE.BUILDING_DESCRIPTION.OPTIONS.BASEMENT_TYPE')}
                disabled={disabled}
            />
            <FormRadioGroup
                name={`${prefix}.kellerausbau`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.GROUPS.BASEMENT_DEVELOPMENT')}
                options={optionValues(
                    BASEMENT_DEVELOPMENT_TYPES,
                    t,
                    'REAL_ESTATE.BUILDING_DESCRIPTION.OPTIONS.BASEMENT_DEVELOPMENT',
                )}
                disabled={disabled}
            />
        </div>
    );
};
